<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">HTML Content</label>
      <textarea 
        v-model="localSettings.content"
        class="form-textarea"
        rows="10"
        placeholder="<div>Your custom HTML here...</div>"
        @input="emitUpdate"
      ></textarea>
      <p class="form-help-text">
        ⚠️ HTML will be sanitized for security. Only safe tags and attributes are allowed.
      </p>
    </div>

    <div class="form-group">
      <label class="form-label">CSS Class</label>
      <input 
        v-model="localSettings.class"
        type="text"
        class="form-input"
        placeholder="custom-class"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Preview</label>
      <div class="html-preview" v-html="localSettings.content"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  settings: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localSettings = ref({ 
  content: '<div>Custom HTML</div>',
  class: '',
  ...props.settings 
});

watch(() => props.settings, (newSettings) => {
  localSettings.value = { ...newSettings };
}, { deep: true });

function emitUpdate() {
  emit('update', localSettings.value);
}
</script>

<style scoped>
.form-help-text {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}

.html-preview {
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 12px;
  background: #f9fafb;
  min-height: 60px;
  max-height: 200px;
  overflow: auto;
}

.form-textarea {
  font-family: 'Courier New', monospace;
  font-size: 13px;
}
</style>

